import * as Assets from "Data/Assets";
import * as HLF from "html-living-framework";
import * as Constants from "Data/Constants";
import * as Topics from "Data/Topics";

export class MusicGameLoopButton extends HLF.Input.Draggable {

    protected _bg: PIXI.Sprite;
    protected _debugText = this._visuals.addChild(HLF.PixiUtils.makeText("", Constants.FONT_GEL_MED_35, 35));
    protected _subscriptions: any[] = [];
    private readonly _data: {id: number};

    constructor(pData: {id: number}) {
        super();

        this._bg = this._visuals.addChild(this.getBGSprite(pData));

        this._data = pData;
        if(this._data.id > -1) {
            this._debugText.text = "Loop " + this._data.id;
        }
        else {
            this._debugText.text = "(No Loop)";
        }
        this.hitArea = this._bg.getBounds();

        this._subscriptions.push(
            PubSub.subscribe(HLF.DRAGGABLE_SELECTED, this.onMessageReceived.bind(this)),
            PubSub.subscribe(HLF.DRAG_BEGIN, this.onMessageReceived.bind(this)),
            PubSub.subscribe(Topics.PLAYBACK_STARTED, this.onMessageReceived.bind(this)),
        );
    }
    public get data() {
        return this._data;
    }

    public select() {
        super.select();
        this._debugText.text = "Selected";
    }

    public deselect() {
        super.deselect();
        if(this._data.id > -1) {
            this._debugText.text = "Loop " + this._data.id;
        }
        else {
            this._debugText.text = "(No Loop)";
        }
    }

    protected getBGSprite(pData: {id: number}) {
        return HLF.PixiUtils.makeSprite(
            Assets.MUS_BTN_VAR + (pData.id + 1).toString(),
            Assets.SPRITESHEET_MUSIC_GAME,
        );
    }

    protected dragBegin(): void {
        super.dragBegin();
        this._debugText.text = "Dragging";
        HLF.PixiUtils.sendToFront(this);
    }

    protected dragEnd() {
        super.dragEnd();
        // reset position after drop
        this._visuals.position.set(0);
        if(this._data.id > -1) {
            this._debugText.text = "Loop " + this._data.id;
        }
        else {
            this._debugText.text = "(No Loop)";
        }
    }

    protected onMessageReceived(pTopic: string, pData: any) {
        switch (pTopic) {
            case HLF.DRAGGABLE_SELECTED:
            case HLF.DRAG_BEGIN:
                // cancel selection when another drag starts
                if (pData !== this) {
                    this._visuals.position.set(0);
                    this.deselect();
                }
                break;
            case Topics.PLAYBACK_STARTED:
                this.visible = true;
                break;
            case Topics.RECORDING_ENDED:
                this.visible = false;
                break;
        }
    }
}